import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Company } from 'store/companySlice';

interface ViewCompanyModalProps {
  show: boolean;
  handleClose: () => void;
  company: Company;
}

const ViewCompanyModal: React.FC<ViewCompanyModalProps> = ({
  show,
  handleClose,
  company
}) => {
  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton className="bg-light">
        <Modal.Title className="fs-6">
          <i className="fas fa-eye me-2"></i>
          Company Details
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="container-fluid">
          {/* Basic Information */}
          <div className="row mb-4">
            <div className="col-12">
              <h6 className="text-primary mb-3 border-bottom pb-2">
                Basic Information
              </h6>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label text-700 mb-1">Company Name</label>
              <div className="fs-6">{company.name || '-'}</div>
            </div>
          </div>

          {/* Additional Information */}
          <div className="row">
            <div className="col-12 mb-3">
              <label className="form-label text-700 mb-1">Created At</label>
              <div className="fs-6">
                {company.created_at
                  ? new Date(company.created_at).toLocaleString()
                  : '-'}
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-top-0">
        <Button
          variant="phoenix-secondary"
          onClick={handleClose}
          className="px-4"
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewCompanyModal;
